export default "/images/3176b5135d7d2249221cef4798a57737.avif";